module.exports = __webpack_public_path__ + "static/media/sbr.97f53506.jpg";